import { render, staticRenderFns } from "./AdministrationHeader.vue?vue&type=template&id=144a90fe&scoped=true"
import script from "./AdministrationHeader.vue?vue&type=script&lang=ts"
export * from "./AdministrationHeader.vue?vue&type=script&lang=ts"
import style0 from "./AdministrationHeader.vue?vue&type=style&index=0&id=144a90fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144a90fe",
  null
  
)

export default component.exports